// extracted by mini-css-extract-plugin
module.exports = {"container":"PageContentWrapper_container__8iEvL","containerPadding":"PageContentWrapper_containerPadding__2bSf4","gapBetween":"PageContentWrapper_gapBetween__a_Sb6"};